/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 11.1.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ReverseQuery } from "./ReverseQuery";
import {
  instanceOfReverseQuery,
  ReverseQueryFromJSON,
  ReverseQueryFromJSONTyped,
  ReverseQueryToJSON,
} from "./ReverseQuery";
import type { SearchQuery } from "./SearchQuery";
import {
  instanceOfSearchQuery,
  SearchQueryFromJSON,
  SearchQueryFromJSONTyped,
  SearchQueryToJSON,
} from "./SearchQuery";
import type { SearchStructuredQuery } from "./SearchStructuredQuery";
import {
  instanceOfSearchStructuredQuery,
  SearchStructuredQueryFromJSON,
  SearchStructuredQueryFromJSONTyped,
  SearchStructuredQueryToJSON,
} from "./SearchStructuredQuery";

/**
 * @type BulkRequestQuery
 *
 * @export
 */
export type BulkRequestQuery =
  | ReverseQuery
  | SearchQuery
  | SearchStructuredQuery;

export function BulkRequestQueryFromJSON(json: any): BulkRequestQuery {
  return BulkRequestQueryFromJSONTyped(json, false);
}

export function BulkRequestQueryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BulkRequestQuery {
  if (json == null) {
    return json;
  }
  if (typeof json !== "object") {
    return json;
  }
  if (instanceOfReverseQuery(json)) {
    return ReverseQueryFromJSONTyped(json, true);
  }
  if (instanceOfSearchQuery(json)) {
    return SearchQueryFromJSONTyped(json, true);
  }
  if (instanceOfSearchStructuredQuery(json)) {
    return SearchStructuredQueryFromJSONTyped(json, true);
  }
  return {} as any;
}

export function BulkRequestQueryToJSON(json: any): any {
  return BulkRequestQueryToJSONTyped(json, false);
}

export function BulkRequestQueryToJSONTyped(
  value?: BulkRequestQuery | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }
  if (typeof value !== "object") {
    return value;
  }
  if (instanceOfReverseQuery(value)) {
    return ReverseQueryToJSON(value as ReverseQuery);
  }
  if (instanceOfSearchQuery(value)) {
    return SearchQueryToJSON(value as SearchQuery);
  }
  if (instanceOfSearchStructuredQuery(value)) {
    return SearchStructuredQueryToJSON(value as SearchStructuredQuery);
  }
  return {};
}
